<template>
  <div>    
    <v-data-table
      :headers="[{text: 'Datum', sortable: false, filterable: false, value: 'timeStamp'},{text: 'Tid', sortable: false, filterable: false, value: 'id'},{text: 'Data', sortable: false, filterable: false, value: 'request'}]"
      :items="logentries"
      :loading="isLoading"
      :options.sync="options"
      :server-items-length="totalRows"
      :items-per-page="itemsPerPage"
      item-key="id"      
    >
    <template
      slot="item.id"
      slot-scope="props"
    >
      {{ props.item.timeStamp | time }}
    </template>
    <template
      slot="item.timeStamp"
      slot-scope="props"
    >
      <div class="wbnobreak">{{ props.item.timeStamp | date }}</div>
    </template>
    </v-data-table>
  </div>
</template>

<script>
import API from '@/services/api.js'
import { mapGetters, mapActions } from 'vuex'
import { pageSize } from '@/store/constants'
// @group Person
// PersonLoginLog component
export default {
name: 'PersonLoginLog',
  data: () => ({
    logentries: [],
    options: {
      sortDesc: true
    },
    itemsPerPage: pageSize,
    totalRows: 0
  }),

  computed: {
    ...mapGetters('app', ['isLoading']),
    ...mapGetters('person', ['selectedPerson']),
  },

  watch: {
    'currentPerson.personalNumber': {
      handler: function() {
        this.fetchLoginLog()
      }
    },
    options: {
      handler() {
        this.fetchLoginLog()
      },
      deep: true
    }
  },

  created() {
    this.fetchLoginLog()
  },

  methods: {
    fetchLoginLog() {
      if ((!this.selectedPerson)) return

      const {sortBy, sortDesc, page, itemsPerPage} = this.options
      const startAt = (page - 1) * this.itemsPerPage

      API.listLoginLog ({
        startAt: startAt ? startAt : 0,
        sortBy: sortBy ? sortBy[0] : 'timeStamp',
        sortDesc: sortDesc,
        advSearch: {personalNumber: this.selectedPerson.personalNumber},
        pageSize: this.itemsPerPage
      })
      .then(response => {
        this.logentries = response.data.rows
        this.totalRows = response.data.count
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      })
      
    }
  }

}
</script>

<style>

</style>